<template>
  <v-dialog
    max-width="30%"
    v-model="dialog"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        :color="tag.color"
        dark
        tile
        small
        v-on="on"
      >
        <v-icon
          small
          left
        >
          {{ tag.icon }}
        </v-icon>
        {{ tag.name }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        Project Status
        <v-spacer />
        <v-btn
          icon
          @click="dialog = false"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-select
          v-model="newTag"
          :value="tag.id"
          :items="tags"
          item-value="id"
          item-text="name"
          :loading="loading"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          color="success"
          @click="submit"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Project from "../../models/Project";
export default {
  name: "ProjectTagChip",
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    loading: {
      type: Boolean,
      required: true,
      default: true
    },
    tag: {
      type: Object,
      required: true,
      default: null
    },
    tags: {
      type: Array,
      required: true,
      default: null
    },
  },
  data() {
    return {
      dialog: false,
      newTag: this.tag.id
    }
  },
  methods: {
    submit() {
      Project
        .$put(this.id,{ tag: this.newTag })
        .then(() => this.dialog = false)
    }
  }
}
</script>
